import React from 'react';
import { motion } from 'framer-motion';

// The generated screens ARE already phones — so we render them frameless
// with just a glow + shadow. No extra device border (avoids double-boxing).
export const PhoneMockup = ({ src, alt, className = '', float = true, tilt = false, delay = 0, width = 'w-[280px]' }) => (
  <motion.div
    animate={float ? { y: [-12, 12, -12] } : {}}
    transition={float ? { repeat: Infinity, duration: 6, ease: 'easeInOut', delay } : {}}
    className={`relative ${width} ${className}`}
    style={tilt ? { transform: 'rotateY(-12deg) rotateX(4deg)' } : {}}
  >
    <div className="pointer-events-none absolute inset-0 -z-10 scale-110 rounded-[3rem] bg-brand/25 blur-[70px]" />
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="relative block h-auto w-full drop-shadow-[0_35px_70px_rgba(0,0,0,0.65)]"
    />
  </motion.div>
);

export const FloatingChip = ({ children, className = '', delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.6, delay }}
    className={`animate-floaty ${className}`}
    style={{ animationDelay: `${delay}s` }}
  >
    <div className="flex items-center gap-2 rounded-2xl border border-white/10 bg-[#001826]/85 px-4 py-2.5 shadow-[0_10px_40px_rgba(0,0,0,0.5)] backdrop-blur-xl">
      {children}
    </div>
  </motion.div>
);
